module.exports = __webpack_public_path__ + "static/media/home.208de2f4.svg";